import { MembershipPathSegments } from './membership-path-segments';

export class MembershipRoutes {
  static membershipApplication(): string {
    return `${MembershipPathSegments.application()}`;
  }
}
